import { createAction, props } from '@ngrx/store';
import { TextTemplatesEntity } from '../../entities/text-templates.entity';

export const TextTemplatesActionTypes = {
    Load: createAction('data/TextTemplates/loadAll'),
    UpdateAll: createAction('data/TextTemplates/updateAll', props<{ Payload: Array<TextTemplatesEntity> }>()),
};
